// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { webviCustom16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-webvi-custom': IconWebviCustom;
    }
}

/**
 * The icon component for the 'webviCustom' icon
 */
export class IconWebviCustom extends Icon {
    public constructor() {
        super(webviCustom16X16);
    }
}

registerIcon('icon-webvi-custom', IconWebviCustom);
export const iconWebviCustomTag = 'nimble-icon-webvi-custom';
